export default {
   //URL: 'https://techniker.test/api/'
   URL: 'https://api.my-techniker.de/api/'
}
